var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 138.7 116.8",
    width: 18,
    height: 16,
    fill: "currentColor",
    style: {
      enableBackground: "new 0 0 138.7 116.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.9,27.8c-5.8-5.1-14.6-4.4-19.7,1.4c-5.1,5.8-4.4,14.6,1.4,19.7c-1.8,5.7-11.5,16.4-23.1,15C79.5,62.2,76.1,44.4,76,30 c4.4-2.4,7.3-7,7.3-12.3c0-7.7-6.2-14-14-14c-7.7,0-14,6.2-14,14c0,5.3,3,9.9,7.3,12.3c-0.1,14.3-3.5,32.1-16.5,33.8 c-11.7,1.5-21.3-9.3-23.1-15c5.8-5.1,6.4-13.9,1.4-19.7c-5.1-5.8-13.9-6.4-19.7-1.4C-1,32.8-1.6,41.6,3.4,47.4 c2.4,2.8,5.9,4.5,9.7,4.8l13.2,58.7h43h43l13.2-58.7c3.7-0.2,7.2-1.9,9.7-4.8C140.3,41.6,139.7,32.8,133.9,27.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/Crown.6cbf9a46ad5391af97d048d20213774b.svg";
export { ForwardRef as ReactComponent };